<template>
	<node-view-wrapper class="formula-adapter">
		<DataChip :contentObj="contentObj" :selected="selected" />
	</node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2';
import { b64DecodeUnicode } from '@/components/common/RichTextBox/DataChip/base64-unicode-utils.js';

import { replaceInsertDataStringDictionary } from '@/store/modules/selectedWorkflow/getters';
import { previousStepsData } from '@/store/modules/nodes/getters';

import FormulasService from './formulas-service';
import DataChip from '../DataChip/DataChip';
import { mapGetters } from 'vuex';

export default {
	name: 'FormulaAdapter',
	components: {
		NodeViewWrapper,
		DataChip,
	},
	props: nodeViewProps,
	computed: {
		...mapGetters([replaceInsertDataStringDictionary.fullPath, previousStepsData.fullPath]),
		contentObj() {
			const parsedContent = JSON.parse(b64DecodeUnicode(this.node.attrs.content)); // We convert to base64 in replaceAllDelimitedDataToTipTapFormat, so here we decode it
			const { functionName, paramsList } = FormulasService.getFormulaFunctionData(parsedContent.content);
			return {
				...parsedContent,
				...{
					formulaData: { functionName, paramsList },
					content: paramsList[0],
					getConvertedContent: (content) =>
						FormulasService.convertContentForFormulaChip(content, functionName, paramsList, {
							previousStepsData: this[previousStepsData.fullPath],
							replaceInsertDataStringDict: this[replaceInsertDataStringDictionary.fullPath],
						}),
				},
			};
		},
	},
};
</script>

<style scoped lang="scss">
.formula-adapter {
	display: inline-block;
}
</style>
